import { useCallback, useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";

const DARK_MODE_KEY = "darkMode";

export const useDarkMode = () => {
    const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");
    const [isDark, setIsDark] = useState(() => {
        const stored = localStorage.getItem(DARK_MODE_KEY);
        if (stored !== null) {
            return stored === "true";
        }
        return prefersDark;
    });

    useEffect(() => {
        const stored = localStorage.getItem(DARK_MODE_KEY);
        if (stored === null) {
            setIsDark(prefersDark);
        }
    }, [prefersDark]);

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light");
    }, [isDark]);

    const toggle = useCallback(() => {
        setIsDark((prev) => {
            const next = !prev;
            localStorage.setItem(DARK_MODE_KEY, String(next));
            return next;
        });
    }, []);

    return { isDark, toggle };
};
